import React from 'react';

import Avatar from 'components/Avatar';
import { imagePickSize } from 'utils/general';
import dayjs from 'dayjs';

const LeadRecordProjectItem = ({
  name,
  projectId,
  weddingDate,
  creationStatus,
  image,
  shortname,
  dateFormat = 'MMMM D, YYYY',
}) => {
  let imagePath;
  if (image) {
    const relativePath = image?.resolutions?.square60 ?
      imagePickSize(image, 'square60') :
      imagePickSize(image, 'full');
    imagePath = `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${relativePath}`;
  }

  return (
    <div className="leads-project-item">
      <a
        href={`/app/project/${projectId}/dashboard`}
        className="leads-project-item__link button button--unstyled"
      >
        <div className="leads-project-item__avatar">
          <Avatar
            photo={imagePath}
            text={!imagePath && shortname}
            size={60}
            borderSize={2}
            className="avatar--transparent avatar--dark"
          />
        </div>
        <div className="leads-project-item__details">
          <div className="leads-project-item__name">
            {name}
          </div>
          <div className="leads-project-item__date">
            {dayjs(weddingDate).format(dateFormat)}
          </div>
          {creationStatus !== 'completed' && (
            <div className="leads-project-item__status">
              {creationStatus}
            </div>
          )}
        </div>
      </a>
    </div>
  );
};

export default LeadRecordProjectItem;
